export default __webpack_public_path__ + "static/media/team5.24b9a4de.png";